import {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {loginWorker} from '../features/workerAuth/workerAuthSlice'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import Spinner from '../components/Spinner' 
import {Link} from 'react-router-dom'
import {FaClock} from 'react-icons/fa'
import Button from '../components/ui/Button'

function WorkerLogin (){
    const [phoneNumber, setPhoneNumber] = useState('')
    const [password, setPassword] = useState('')    

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {workerUser, isError, isSuccess, isLoading, message} = useSelector(state => state.workerAuth)

    useEffect(()=>{
        if(isError){
            toast.error(message)
        }
        if(isSuccess && workerUser){
            navigate('/workerDash')
        }
    },[isError,isSuccess,workerUser,message,navigate,dispatch])

    const onChange = (e) => {
        setPassword(e.target.value);
    }

    const stylePhoneNumber = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, ""); // Remove all non-numeric characters
        value = value.substring(0, 10); // Limit to max 10 digits

        // Add dashes
        if (value.length > 6) {
            value = value.substring(0, 3) + "-" + value.substring(3, 6) + "-" + value.substring(6);
        } else if (value.length > 3) {
            value = value.substring(0, 3) + "-" + value.substring(3);
        }

        setPhoneNumber(value);
    }   

    const onSubmit = (e)=>{
        e.preventDefault()
        
        const workerPhone = phoneNumber.replace(/-/g, "")
        
        const workerCredentials = {
            phoneNumber : workerPhone,
            password
        }

        dispatch(loginWorker(workerCredentials))

    }
  
    if(isLoading){
        return <Spinner/>
    }

    return(
    <>
        <div className="min-h-screen flex items-center justify-center bg-bg">
            <div className="max-w-7xl w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="hidden lg:flex flex-col items-center justify-center">
                    <h1 className="text-5xl font-semibold text-ink">TIMESTAT</h1>
                    <p className="mt-4 text-xl text-ink-2">Fraud-free jobsite attendance tracking</p>
                </div>

                <div className="max-w-md w-full mx-auto lg:mx-0 space-y-8 bg-surface rounded-xl border border-border shadow-sm flex flex-col justify-center flex-grow px-8 py-8">
                    <div>
                        <FaClock className="mx-auto h-12 w-auto text-ink-3"/>
                        <h2 className="mt-4 text-center text-4xl font-semibold text-ink">
                            Worker Login
                        </h2>
                    </div>

                    <form className="space-y-4" onSubmit={onSubmit}>
                        <input type="hidden" name="remember" value="true" />
                        <div className="space-y-3">
                            <div>
                                <label htmlFor="phoneNumber" className="sr-only">Phone Number</label>
                                <input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="tel"
                                    value={phoneNumber}
                                    onChange={stylePhoneNumber}
                                    required
                                    className="w-full rounded-md border border-border bg-surface px-3 py-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40"
                                    placeholder="347-123-1234"
                                    inputMode='numeric'
                                />
                            </div>
                            <div>
                                <label htmlFor="password" className="sr-only">Password</label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    value={password}
                                    onChange={onChange}
                                    required
                                    className="w-full rounded-md border border-border bg-surface px-3 py-2 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40"
                                    placeholder="Password"
                                />
                            </div>
                        </div>

                        <div>
                            <Button type="submit" className="w-full text-base">
                                Log In
                            </Button>
                        </div>
                    
                    </form>
                    {/* End of Form  */}

                    <div className="mt-6 text-center">
                        <Link to="/resetWorkerPassword" className="underline p-2 rounded-md">
                            Forgot Password ?
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default WorkerLogin
